module.exports = __webpack_public_path__ + "static/media/platinum-lambo.2163d071.png";